module.exports = __webpack_public_path__ + "static/media/card-dark-bg.3ec5ad04.jpg";